export const SET_SIDO_LIST = 'SET_SIDO_LIST';
export const SET_SIGUNGU_LIST = 'SET_SIGUNGU_LIST';
export const SET_SIDO = 'SET_SIDO';
export const SET_SIGUNGU = 'SET_SIGUNGU';

export const setSido = (payload: any) => ({
  type: SET_SIDO,
  payload,
});
export const setSigungu = (payload: any) => ({
  type: SET_SIGUNGU,
  payload,
});
export const setSidoList = (payload: any) => ({
  type: SET_SIDO_LIST,
  payload,
});
export const setSigunguList = (payload: any) => ({
  type: SET_SIGUNGU_LIST,
  payload,
});

type StorageActions =
  | ReturnType<typeof setSido>
  | ReturnType<typeof setSigungu>
  | ReturnType<typeof setSidoList>
  | ReturnType<typeof setSigunguList>;

export interface StorageState {
  sidoList: any;
  sigunguList: any;
  sido: string | null;
  sigungu: string | null;
}

const initialState: StorageState = {
  sidoList: [],
  sigunguList: [],
  sido: '',
  sigungu: '',
};

export default function branchMapReducer(
  state: StorageState = initialState,
  action: StorageActions,
): StorageState {
  switch (action.type) {
    case SET_SIDO_LIST:
      return { ...state, sidoList: action.payload };
    case SET_SIGUNGU_LIST:
      return { ...state, sigunguList: action.payload };
    case SET_SIDO:
      return { ...state, sido: action.payload };
    case SET_SIGUNGU:
      return { ...state, sigungu: action.payload };
    default:
      return state;
  }
}
